<template>
    <div class="root" v-loading="loading">
        <router-link to="/" replace>
            <div class="header">
                <div class="iconfont back-icon">&#xe624;</div>
                <div class="headertxt">
                    答题结果
                </div>
            </div>
        </router-link>

        <div class="questiondiv">

            <div style="text-align:center; margin:30px 0; font-weight: bold">答题共用时{{ time }},得分</div>

            <div style="font-size:2rem; text-align:center; color:#BD0E17;">
                {{ defen }}<span style="font-size:16px; color:#000;">分</span>
            </div>

            <div style="display:flex; margin:35px 0; align-items: center; line-height: 24px; font-weight: bold;">
                <div style="flex:1; text-align:center;">
                    <div>答对</div>
                    <div>{{ dui }}</div>
                </div>
                <div style="width:1px; height:20px; background:#999;"></div>
                <div style="flex:1; text-align:center;">
                    <div>答错</div>
                    <div>{{ cuo }}</div>
                </div>
            </div>

            <div>
                <router-link to="/cuotiji" v-if="learned != 1">
                    <el-button type="warning" style="width:100%">查看错题</el-button>
                </router-link>

                <div style="margin-top:20px"></div>
                <router-link replace to="/paihangbang">
                    <el-button type="danger" style="width:100%">查看排名</el-button>
                </router-link>

            </div>

        </div>

    </div>
</template>

<script>

import axios from 'axios'
import { Result } from 'element-ui'

export default {
    name: 'userresult',
    data: function () {
        return {
            time: '00:00',
            defen: 0,
            dui: 0,
            cuo: 0,
            loading: false,
            learned: 0
        }
    },
    components: {
    },
    methods: {
        getHomeInfo() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Question/userresult',
                {
                    limit: 50,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.getHomeInfoSucc)
        },
        getHomeInfoSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.time = res.time,
                    this.defen = res.defen,
                    this.dui = res.dui,
                    this.cuo = res.cuo,
                    this.learned = res.learned
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/');
                }
            }
        },
    },
    mounted() {
        this.getHomeInfo()
    }
}
</script>
<style scoped>
.root {
    background-repeat: no-repeat;
    background-size: 100%;
    width: 100%;
    height: 100vh;
    overflow-y: scroll;
}

.header {
    padding: .24rem;
    display: flex;
}

.headertxt {
    flex: 1;
    text-align: center;
    color: #fff;
    margin-right: 20px;
    line-height: 20px;
}

.back-icon {
    font-size: .4rem;
    color: #fff;
}

.questiondiv {
    height: calc(100vh - 30vh);
    overflow-y: scroll;
    background: #fff;
    width: 90vw;
    margin: 10vh auto 10vh auto;
    padding: 12px;
    border-radius: 5px;
    box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/pages/userresult/userresult.vue